import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMultiSelectRequest, setMultiSelectValue } from "../../misc/MultiSelectRequest";
import PopupLoader from "../../PopupLoader";
import MultiSaveLimitAlert from "../../../../apiclients/MultiSaveLimitAlert";

const ResendWelcomeEmail = forwardRef((props, ref) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const [warningMsg, setwarningMsg] = useState([]);
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const [saveWarningMessage, setsaveWarningMessage] = useState("");
    const [allEntriesDicard, setAllEntriesDicard] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        getResendMail();

    }, []);

    async function getResendMail() {
        props.setIsloading(true);
        const tdata = await getMultiSelectRequest(11, props.agentList, props.moduleType);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }

        setwarningMsg(tdata?.result?.message ? [tdata?.result?.message] : []);
    }
    async function handleResendMail(value, confirmFlag) {
        let tdata = null;
        props.setIsloading(true);
        if (confirmFlag) {
            tdata = await setMultiSelectValue(11, "", props.agentList, props.moduleType, 1, 1);
        } else {
            tdata = await setMultiSelectValue(11, "", props.agentList, props.moduleType, 1);
        }
        props.setIsloading(false);

        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        if (tdata.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/userlanding";
        } else if (tdata.status == "failed") {
            if (tdata.exceededErrMsg) {
                setsaveWarningMessage(tdata.exceededErrMsg);
                if(tdata.all_grps_discarded) {
                    setAllEntriesDicard(true);
                }
                warningToggle();
                return;
            }
        } else {
            console.log("resend mail for multi select ::::::::::::: " + JSON.stringify(tdata));
            localStorage.setItem("s_message", tdata.message);

            if (props.locUser) {
                navigate("/locationsusers", {
                    state: { tab: props.locUser },
                });

            } else if (props.groupInfo) {
                navigate("/usersgroups", {
                    state: { tab: props.groupInfo },
                });

            } else if (props.groupUInfo) {
                navigate("/SelectedUserGroupSettings", {
                    state: { tab: "tab2", groupUInfo: props.groupUInfo },
                });
            } else if (props.usergroups) {
                navigate("/userlanding", {
                    state: { tab: "mgroups" },
                });

            } else if (props.userLoc) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sloc" },
                });

            } else if (props.userAllgroups) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sgroups" },
                });



            } else {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "suser" },
                });
            }
            props.onClose();

            window.location.reload();
        }
    }

    return (
        <>
            <div>
                <span className="phrecording">
                    {t("sendWelcomeEmailtxt")}
                </span>
            </div>
            {warningMsg && warningMsg.map((meg) => (
                <div className="pt-2 phrecording">
                    {meg}
                </div>
            ))}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleResendMail() }}>
                    {t("add")}</button>
            </div>
            {showWarning && (
                <>
                    <PopupLoader
                        title="Warning"
                        content={
                            <MultiSaveLimitAlert
                                saveWarningMessage={saveWarningMessage}
                                onClose={warningToggle}
                                handleClick={() => { if(allEntriesDicard) {warningToggle(); props.onClose(); return;}handleResendMail(null, 1);}}
                            />

                        }
                        onShow={setShowWarning}
                        onClose={warningToggle}
                    />

                </>
            )}
        </>
    )
});

export default ResendWelcomeEmail
